<template>
  <div class="col-auto">
    <div class="sortByDropdownContainer">
      <div class="dropdown">
        <span class="mr-2"><small>Sort by</small></span>
        <button
          ref="sortByButton"
          data-toggle="dropdown"
          id="sortResults"
          :aria-label="`${getSortByText}, currently sorting by ${getSortByText}, click to open sort menu`"
          class="dropdown-toggle btn btn-link"
          role="button"
        >
          {{ getSortByText }}
        </button>
        <div class="dropdown-menu" role="listbox" ref="listbox">
          <a
            href="#"
            class="dropdown-item"
            v-for="option in options"
            :key="option.value"
            @click="onOptionClicked(option.value)"
            role="option"
            :aria-label="`sort by ${option.text}`"
          >
            {{ option.text }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { title } from '@/utilities/filters'
export default {
  props: {
    buttonText: String,
    options: { required: true, type: Array },
    value: [Number, String],
  },
  computed: {
    getSortByText() {
      const { $t, buttonText, value } = this
      if (buttonText) return buttonText
      else if (value) return title(value)
      else return title($t('ui.sortBy'))
    },
  },
  methods: {
    onOptionClicked(e) {
      this.$emit('input', e)
      this.$refs.sortByButton.focus()
    },
  },
}
</script>
